import React from "react";
import ReactDOM from "react-dom";
import HomePage from "./components/homepage";

const homepage = document.getElementById("homepage-root");

ReactDOM.render(<HomePage />, homepage);
